import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { AutobizNavBar } from 'autobiz-strap';
import { t } from 'autobiz-translate';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import Alert from '../Alert';
import Translate from '../Translate';
import LogOutAlertModel from '../Modal/LogOutAlertModel';
import getFormsLocal from '../../../services/Form/getFormsLocal';
import { flags, languages } from '../../../language-context';
import { Auth, recordListActions } from '../../../config/configuration/react';
import checkStorageBeforeLogout from '../../../services/Auth/checkStorageBeforeLogout';
import clearDataLogOut from '../../../services/Auth/clearDataLogout';
import { autobizOfficeUrl } from '../../../config';
import useAuth from '../../../hooks/useAuth0/useAuth';
import ZohoSurvey from '../../NpsPopup/ZohoSurvey';

const ENV = process.env.REACT_APP_ENV;

const Header = (props) => {
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState(['', {}]); // array[translateCode, {variables}]
  const [redirect] = useState(false);
  const [localForms, setLocalForms] = useState(false);
  const [showLogoutBtn, setShowLogoutBtn] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const userFeedsCount = useSelector((state) => state.recordList?.totalFeeds);
  const [country, setCountry] = useState(Cookies.get('appLanguage') || Auth.preferredLanguage());
  const { alerts, alert } = props;
  const userCountry = Auth.country();
  const checkCountry = userCountry || country;
  const dispatch = useDispatch();
  const apps = Auth.currentUserApps(country);
  const isOnlyNrmUser = Auth.isOnlyNrmUser();
  const { authStatus, logout } = useAuth();
  let interval = null;
  const userProvider = Auth.provider();
  const userJourneyIds = Auth.journeys();
  const userContractJourneyId = Auth.contract();
  const user = Auth.currentUser();
  const [appLang, setAppLang] = useState(Cookies.get('appLanguage') || Auth.preferredLanguage());

  useEffect(() => {
    const loadZohoScript = (src, useInsertBefore = false) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.defer = true;
      script.id = 'zohodeskasapscript';
      script.nonce = '{place_your_nonce_value_here}';
      script.src = src;

      if (useInsertBefore) {
        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    };

    const existingScript = document.getElementById('zohodeskasapscript');
    if (existingScript) {
      existingScript.remove();
    }

    if (checkCountry === 'ES') {
      loadZohoScript('https://desk.zoho.eu/portal/api/web/asapApp/97131000033984055?orgId=20080924920');
    } else if (checkCountry === 'PT') {
      loadZohoScript('https://desk.zoho.eu/portal/api/web/inapp/97131000016642075?orgId=20080924920');
    } else if (['BE', 'AT', 'LU', 'NL', 'SE', 'UK', 'DE'].includes(checkCountry)) {
      const d = document;
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.id = 'zohodeskasapscript';
      s.defer = true;
      s.nonce = '{place_your_nonce_value_here}';
      s.src = 'https://gc.zohopublic.eu/org/20091848743/flows/740000005524029/embed/script';
      const firstScript = d.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(s, firstScript);

      window.ZohoDeskAsapReady = function zohoDeskReady(callback) {
        window.ZohoDeskAsap_asyncalls = window.ZohoDeskAsap_asyncalls || [];
        const e = window.ZohoDeskAsap_asyncalls;
        if (window.ZohoDeskAsapReadyStatus) {
          if (callback) e.push(callback);
          e.forEach((fn) => fn && fn());
          window.ZohoDeskAsap_asyncalls = null;
        } else if (callback) {
          e.push(callback);
        }
      };
    } else if (checkCountry === 'IT') {
      loadZohoScript('https://desk.zoho.eu/portal/api/web/asapApp/97131000033709801?orgId=20080924920');
    } else if (checkCountry === 'FR') {
      loadZohoScript('https://desk.zoho.eu/portal/api/web/asapApp/97131000029274017?orgId=20080924920');
    }
  }, [checkCountry]);

  const getUserFeeds = async () => dispatch(recordListActions.getUserFeeds());

  useEffect(() => {
    let mounted = false;
    if (authStatus === 'success') {
      if (!mounted) {
        interval = setInterval(() => {
          getUserFeeds();
        }, 300000);
        setShowLogoutBtn(true);
      }
    } else setShowLogoutBtn(false);

    return () => {
      clearInterval(interval);
      mounted = true;
    };
  }, [authStatus]);

  const toggleAlert = () => {
    setOpenAlert(!openAlert);
  };

  function sortAlerts(a, b) {
    if (a.color === 'danger' || (a.color === 'warning' && b.color === 'success')) return 1;
    if (a.color === b.color) return 0;
    return -1;
  }

  let alertsObj;
  if (alerts) {
    const alertsArray = _.flatMap(alerts);
    alertsArray.sort(sortAlerts);
    alertsObj = alertsArray.map((a, index) => {
      setTimeout(() => a.onClose(index), 3000);
      return (
        <Alert key={a.id} color={a.color} visible={a.visible} hideOfflineAlert={() => a.onClose(index)}>
          {a.text}
        </Alert>
      );
    });
  }

  const handleLogout = async () => {
    try {
      await clearDataLogOut(localForms);
      await logout({
        logoutParams: {
          returnTo: window.location.origin,
          federated: true,
        },
      });
    } catch (e) {
      setMessage([e.message, {}]);
    }
  };

  useEffect(() => {
    if (languages[appLang] != null) {
      document.title = languages[appLang].title;
    } else {
      document.title = 'Carcheck';
    }
  }, [appLang]);
  const onLogoutButtonEvent = async () => {
    const forms = await getFormsLocal(true);
    setLocalForms(forms);
    const [messageLogout, variables] = await checkStorageBeforeLogout(forms);
    setMessage([messageLogout, variables]);
    setOpenAlert(true);
  };

  const handleChangeLang = async (language, languageId) => {
    setCountry(language);
    setAppLang(language);
    if (language === 'var') Cookies.set('appLanguage', language, { expires: 365 });
    if (languageId) {
      Cookies.remove('appLanguage');
      Auth.updatePreferredLanguage(languageId, language);
    }
    window.dispatchEvent(new CustomEvent('changeLanguage', { detail: { language } }));
    if (window.location.href.includes('content')) window.location.reload();
  };

  const getContactHeader = () => {
    let contact;
    if (userCountry === 'FR') contact = 'mailto:supportclientb2b@autobiz.com';
    else if (['ES', 'PT'].includes(userCountry)) contact = 'mailto:contactar@autobiz.com';
    else if (userCountry === 'IT') contact = 'mailto:supportoclienti@autobiz.com';
    else if (
      [
        'DE',
        'UK',
        'NL',
        'AT',
        'CZ',
        'CH',
        'RO',
        'SE',
        'DK',
        'PL',
        'GR',
        'IE',
        'HU',
        'FI',
        'SK',
        'NO',
        'BE',
        'LU',
      ].includes(userCountry)
    )
      contact = 'mailto:support@autobiz.com';
    else contact = 'mailto:contact-carcheck@autobiz.com';
    return contact;
  };

  const getTermsAndConditionsLink = () => {
    const termsAndConditionsLink = t('tcLink');
    return termsAndConditionsLink;
  };

  const getCookiesPolicyLink = () => {
    const cookiesPolicyLink = t('cookiesPolicyLink');
    return cookiesPolicyLink;
  };

  const getPrivacyPolicyLink = () => {
    const privacyPolicyLink = t('privacyPolicyLink');
    return privacyPolicyLink;
  };

  const getGcuLink = () => {
    const gcuLink = t('gcuLink');
    return gcuLink;
  };

  const getMenu = () => (
    <>
      <div className={openMenu ? 'menu-container open' : 'menu-container'} id="menu_container">
        <ul>
          {languages.map(
            (lang) =>
              lang.language_iso2 !== country.toLowerCase() && (
                <li onClick={() => handleChangeLang(lang.language_iso2, lang.id)} key={lang.language_iso2} aria-hidden>
                  <img src={flags[lang.language_iso2]} className="icon-flag" alt="" />
                  <span className="ml-2">{_.toUpper(lang.language_iso2)}</span>
                </li>
              ),
          )}
          {ENV !== 'prod' && (
            <li onClick={() => handleChangeLang('var')} key="var" aria-hidden>
              <img src={flags.var} className="icon-flag" alt="" />
              <span className="ml-2">{_.toUpper('var')}</span>
            </li>
          )}
        </ul>
      </div>
    </>
  );

  const handleClickOutsideMenu = (event) => {
    // const domNode = ReactDOM.findDOMNode(this);
    const menuContainer = document.getElementById('menu_container');

    if (
      menuContainer !== undefined &&
      menuContainer !== null &&
      menuContainer.contains(event.target) === false &&
      event.target.id !== 'menuToggler'
    ) {
      setOpenMenu(false);
    }
  };

  const toggleMenu = () => {
    setOpenMenu((prevState) => !prevState);
    if (openMenu) {
      document.removeEventListener('click', handleClickOutsideMenu, true);
    } else {
      document.addEventListener('click', handleClickOutsideMenu, true);
    }
  };
  const getLang = () => (
    <>
      <hr style={{ margin: '0 -10px 10px -10px' }} />
      <Translate code="languages" />
      <div className="lang-icon">
        <img src={_.get(flags, country.toLowerCase(), 'fr')} className="icon-flag mr-2" alt="" />
        {country?.toUpperCase()}
      </div>
      {getMenu()}
    </>
  );

  const openNewPage = (url, newTab = false) => {
    if (newTab) return window.open(url, '_blank');
    window.location.href = url;
    return window.location.href;
  };

  const getHelp = () => {
    const baseHelpLink = 'https://support.autobiz.com/portal/';
    const languagePaths = ['fr', 'es', 'it', 'en', 'de', 'nl', 'pt'];
    const help = [
      {
        name: t('help_support_link'),
        onClick: () => {
          const lang = languagePaths.includes(appLang) ? appLang : 'en';
          const helpLink = `${baseHelpLink}${lang}/kb/autobizcarcheck`;
          openNewPage(helpLink, true);
        },
      },
    ];
    if (showLogoutBtn) {
      help.push({
        name: t('contact_us'),
        onClick: () => openNewPage(getContactHeader()),
      });
      if (['AZ'].includes(userProvider)) {
        help.push({
          name: t('gcuTitle'),
          onClick: () => openNewPage(getGcuLink(), true),
        });
      }
      if (!['STLA', 'SMART'].includes(userProvider)) {
        help.push({
          name: t('terms_and_conditions'),
          onClick: () => openNewPage(getTermsAndConditionsLink(), true),
        });
      }
      help.push({
        name: t('cookiesPolicyTitle'),
        onClick: () => openNewPage(getCookiesPolicyLink(), true),
      });
      help.push({
        name: t('privacyPolicyTitle'),
        onClick: () => openNewPage(getPrivacyPolicyLink(), true),
      });
    }
    return help;
  };

  const getContractType = () => {
    let contractType = '';
    switch (userProvider) {
      case 'AZ':
        contractType = 'autobiz_contract';
        break;
      case 'STLA':
        contractType = 'stla_contract';
        break;
      case 'SMART':
        contractType = 'smart_contract';
        break;
      default:
        contractType = '';
    }
    return (
      <span style={{ display: 'inline-block', marginLeft: -50, marginTop: 10 }}>
        <strong>{t('contractName')} :</strong> {t(contractType)}
      </span>
    );
  };

  const getJourney = () => {
    let packageLabel;
    if (userJourneyIds.includes(1) && userJourneyIds.includes(2)) {
      packageLabel = 'package3';
    } else if (userJourneyIds.includes(1)) {
      packageLabel = 'package1';
    } else if (userJourneyIds.includes(2)) {
      packageLabel = 'package2';
    }
    let contractJourneyLabel = '';
    if (userJourneyIds.includes(1) && !userJourneyIds.includes(2)) {
      contractJourneyLabel = '';
    } else if (userContractJourneyId === 1) {
      contractJourneyLabel = 'contractJourneyLabelStellantis';
    } else if (userContractJourneyId === 2) {
      contractJourneyLabel = 'contractJourneyLabelSmart';
    } else if (userContractJourneyId === 3) {
      contractJourneyLabel = 'contractJourneyLabelSol';
    }
    return (
      <span style={{ display: 'inline-block', marginLeft: -50 }}>
        <strong>{t('licenceName')} :</strong> {t(packageLabel)}
        {contractJourneyLabel && <> - {t(contractJourneyLabel)}</>}
      </span>
    );
  };

  const menu = {
    apps: showLogoutBtn && apps, // apps comming form autobiz auth
    help: getHelp(), // TODO add items {name : string, onClick : function} not required
    languages: [{ name: getLang(), onClick: toggleMenu }], // TODO add items {name : string, onClick : function} not required
    user: showLogoutBtn && {
      firstName: Auth.firstName(),
      lastName: Auth.lastName(),
      country: Auth.country(),
      email: [
        { key: 'email', value: Auth.email() },
        { key: 'contractType', value: getContractType() },
        { key: 'journey', value: getJourney() },
      ].map(({ key, value }) => <div key={key}>{value}</div>),
      logout: () => onLogoutButtonEvent(),
    }, // TODO change user props
  };

  if (userFeedsCount !== undefined && showLogoutBtn && isOnlyNrmUser === false) {
    menu.notifications = {
      count: userFeedsCount,
      url: `${autobizOfficeUrl}/${country.toLowerCase()}/`,
      newTab: true,
      // };
    };
  }

  return (
    <>
      {redirect && <Redirect to={redirect} />}

      <AutobizNavBar
        maxWidth={1880}
        lang={country.toLowerCase() === 'var' ? 'fr' : country.toLowerCase()} // TODO change with current lang
        brand="autobizCarcheck"
        menu={menu}
      />
      <LogOutAlertModel isOpen={openAlert} onClose={toggleAlert} logoutToggle={handleLogout} message={message} />
      {alertsObj}
      {alert}
      <ZohoSurvey user={{ ...user, country: userCountry }} />
    </>
  );
};

Header.propTypes = {
  alert: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  alerts: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape()), PropTypes.objectOf(PropTypes.shape())]),
};
Header.defaultProps = {
  alert: undefined,
  alerts: [],
};

export default Header;
